const TwoDimensionalCode = () => import('@/views/two-dimensional-code/two-dimensional-code.vue')
export default [
  {
    path: '/TwoDimensionalCode',
    name: 'TwoDimensionalCode',
    component: TwoDimensionalCode,
    meta: {
      keepAlive: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/TwoDimensionalCode.js